import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";

import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { ToastrModule } from "ngx-toastr";

import {
    HubLoginModule,
    HubAuthorizationModule,
    HubLogoModule,
    TrInputsModule
} from "@toro/common/shared/components";

// GLOBAL COMPONENTS
import { FooterModule } from "@toro/common/shared/components";
import {
    SvgIconModule,
    TrLoadingOverlayModule,
    HubNavModule
} from "@toro/common/shared/components";
import {
    TooltipDirectiveModule,
    TrackingDirectiveModule
} from "@toro/common/shared/directives";
import { FirstNamePipeModule } from "@toro/common/shared/pipes";
import { TrAccordionModule } from "@toro/common/shared/components";
import { CpfCnpjPipeModule } from "@toro/common/shared/pipes";
import { CustomWalletBuilderComponent } from './custom-wallet-builder.component';
import { StepperComponent } from '../../../shared/components/stepper/stepper.component';
import { CurrencyMaskModule } from 'ng2-currency-mask';

@NgModule({
    imports: [
        CommonModule,
        CpfCnpjPipeModule,
        CurrencyMaskModule,
        HubNavModule,
        FirstNamePipeModule,
        FormsModule,
        ReactiveFormsModule,
        HubLoginModule,
        HubAuthorizationModule,
        SvgIconModule,
        TooltipDirectiveModule,
        FooterModule,
        RouterModule,
        ToastrModule.forRoot({
            timeOut: 0,
            maxOpened: 1
        }),
        TrAccordionModule,
        TrackingDirectiveModule,
        TrInputsModule,
        TrLoadingOverlayModule,
        HubLogoModule
    ],
    declarations: [CustomWalletBuilderComponent, StepperComponent],
    providers: [],
    exports: [CustomWalletBuilderComponent]
})
export class CustomWalletBuilderModule {}
